import { db } from './firebase'; // Importa la instancia de tu base de datos de Firebase
import { collection, getDocs } from 'firebase/firestore';

// Función para obtener todos los documentos de una colección
export const getCollectionData = async (collectionName) => {
  try {
    const querySnapshot = await getDocs(collection(db, collectionName));
    const data = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));
    return data;
  } catch (error) {
    console.error(`Error fetching ${collectionName} documents:`, error);
    throw error;
  }
};